<ng-container>
  @if (showHeader) {
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center">
      @if (!useSmallHeaderLabel && showHeaderLabel) {
        <div>
          <h3>{{ headerLabel }}</h3>
        </div>
      }
      @if (useSmallHeaderLabel && showHeaderLabel) {
        <div>
          <h5>{{ headerLabel }}</h5>
        </div>
      }
      <div>
        <ng-content select=".custom-button"></ng-content>
      </div>
      @if (showNewItem) {
        <div
          fxLayout="row"
          fxLayoutAlign="end">
          <button
            type="button"
            class="button is-primary is-medium"
            (click)="onNewItemClick()">
            <i class="icon icon-add_plus_zoom-in"></i>
            <span>{{ newItemLabel }}</span>
          </button>
        </div>
      }
    </div>
  }
  <div class="mt-3">
    @if (showTableInfo) {
      <div
        fxLayout="row"
        fxLayoutAlign="space-between"
        class="mb-3">
        @if (showCount) {
          <div class="table-label">{{ hasIndependentTotalCount ? independentTotalCount : totalCount }} {{ headerLabel }}</div>
        } @else {
          <div>&nbsp;</div>
        }
        @if (showSearch) {
          <div style="position: relative">
            <input
              class="input is-small is-iconleft search-control"
              type="text"
              [placeholder]="searchPlaceholder"
              [formControl]="searchControl" />
            <i
              class="icon icon-search"
              style="position: absolute; top: 14px; left: 6px; color: var(--neutral-color-400)"></i>
          </div>
        }
      </div>
    }

    <div [ngClass]="{ tableScrollContainer: horizontalScrollActive }">
      <table
        class="table topo-table"
        [ngClass]="{ 'no-borders': !showBorders }"
        style="width: 100% !important"
        (cdkDropListDropped)="drop($event)"
        cdkDropList>
        <thead>
          <tr>
            @if (showSelectionHeader() && enableSelectionHeader()) {
              <th colspan="100%">
                <ng-content select="selection-header" />
              </th>
            } @else {
              @for (col of columns; track col.id) {
                <th [ngClass]="col?.headerCssClass">
                  @if (col.sortField) {
                    <div
                      fxLayout="row"
                      fxLayoutAlign="start center"
                      style="cursor: pointer"
                      (click)="onSort(col.sortField)">
                      <div>{{ col.label }}</div>
                      @if (col.sortField === sortField && sortDirection === 'Ascending') {
                        <div style="margin-left: 4px">&#9650;</div>
                      }
                      @if (col.sortField === sortField && sortDirection === 'Descending') {
                        <div style="margin-left: 4px">&#9660;</div>
                      }
                    </div>
                  }
                  @if (!col.sortField) {
                    <div
                      fxLayout="row"
                      fxLayoutAlign="start center">
                      {{ col.label }}
                    </div>
                  }
                  @if (!col.sortField && col.hasCheckbox) {
                    <label class="checkbox-input remove-system-style pl-xs">
                      <input
                        type="checkbox"
                        (click)="onCheckboxSelected($event)"
                        class="checkbox-input"
                        [checked]="col.isChecked"
                        [disabled]="col.checkboxDisabled" />
                      <span></span>
                    </label>
                  }
                </th>
              }
            }
          </tr>
        </thead>
        <tbody>
          @if (!items || items.length === 0) {
            <tr>
              <td
                [attr.colspan]="columns.length"
                class="pt-4 pb-4"
                style="text-align: center">
                <div class="my-4">{{ 'TABLE.NO-ITEMS' | translate }}</div>
              </td>
            </tr>
          }
          @for (item of items; track trackItem($index, item)) {
            <tr
              cdkDrag
              [cdkDragDisabled]="!enableDragDrop">
              @if (enableDragDrop) {
                <div
                  *cdkDragPreview
                  matchSize="true">
                  <table style="width: 100%">
                    <tr>
                      @for (col of columns; track col.id) {
                        <td
                          [ngClass]="col?.cellCssClass"
                          [ngStyle]="col?.cellStyle"
                          style="vertical-align: middle">
                          <ng-container
                            [ngTemplateOutlet]="col.columnTemplate"
                            [ngTemplateOutletContext]="{ item: item, col: col }"></ng-container>
                        </td>
                      }
                    </tr>
                  </table>
                </div>
              }
              @for (col of columns; track col.id) {
                <td
                  [ngClass]="col?.cellCssClass"
                  [ngStyle]="col?.cellStyle">
                  <ng-container
                    [ngTemplateOutlet]="col.columnTemplate"
                    [ngTemplateOutletContext]="{ item: item, col: col }"></ng-container>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
    @if (showPager && items?.length > 0) {
      <topo-pager
        [skip]="skip"
        [take]="take"
        [totalCount]="totalCount"
        (paginate)="onPaginate($event)"
        [showChangeRowCount]="showChangeRowCount"
        (takeChanged)="onTakeChanged($event)"></topo-pager>
    }
  </div>
</ng-container>
